// src/Sidebar.js
//
// WHAT THIS FILE IS:
// Renders the left-hand navigation menu, and highlights whichever page
// is currently active based on the browser's URL.

import { Link, useLocation } from 'react-router-dom';
// Link works like a normal <a> tag but WITHOUT causing a full page
// reload - React Router intercepts the click and just swaps out which
// component is shown, keeping the app fast (this is what "Single Page
// Application" means).
//
// useLocation is a Hook that tells us the CURRENT url path, so we can
// compare it against each link to know which one to visually highlight.

function Sidebar() {
  // location.pathname is a string like "/activities" or "/staff".
  const location = useLocation();

  // A plain JavaScript array of objects describing each nav link, so we
  // can .map() over it below instead of repeating the same JSX 5 times.
  const links = [
    { path: '/', label: 'Projects' },
    { path: '/activities', label: 'Activities' },
    { path: '/staff', label: 'Staff' },
    { path: '/beneficiaries', label: 'Beneficiaries' },
    { path: '/tasks', label: 'Tasks' },
    { path: '/budgets', label: 'Budgets' },
    { path: '/impact-records', label: 'Impact Records' },
    { path: '/feedback', label: 'Feedback' },
    { path: '/attachments', label: 'Attachments' },
  ];

  return (
    // w-56 = fixed width sidebar, h-screen = full height, bg-gray-900 =
    // dark background, text-white = default text color for everything inside
    <div className="w-56 h-screen bg-gray-900 text-white flex flex-col p-4">
      <h2 className="text-lg font-bold mb-6">PMIS</h2>

      {/* .map() loops over the links array and returns one JSX element
          per item - this is the standard React way to render a list. */}
      {links.map((link) => (
        <Link
          key={link.path}
          // key is REQUIRED by React whenever rendering a list from
          // .map() - it needs a unique identifier per item to
          // efficiently track which items changed/moved/were removed.
          to={link.path}
          // Conditionally apply a different background class if this
          // link's path matches the current page, so the active page is
          // visually highlighted in the sidebar.
          className={`px-3 py-2 rounded mb-1 ${
            location.pathname === link.path ? 'bg-gray-700' : 'hover:bg-gray-800'
          }`}
        >
          {link.label}
        </Link>
      ))}
    </div>
  );
}

export default Sidebar;
